import { SET_PRICES, SET_PRICE_PLANS, SET_PRODUCT, SET_PRODUCTS } from "../../constants/productConstants";

export const setProduct = (product) => {
  return {
    type: SET_PRODUCT,
    product,
  };
};
export const setPricePlans = (pricePlans) => {
  return {
    type: SET_PRICE_PLANS,
    pricePlans,
  };
};
export const setPrices = (prices) => {
  return {
    type: SET_PRICES,
    prices,
  };
};

export const setProducts = (products, isProduct, filtered = false, all = false) => {
  return {
    type: SET_PRODUCTS,
    products,
    isProduct,
    filtered,
    all,
  };
};
